/**
 * Created by Sravanth on 06-19-2020.
 */
export class Tutorialsprops {
  public static get hy(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get 'zh-Hans'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get 'zh-Hant'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get cs(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 74,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get da(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 74,
      TN_pays_blank_position_17_Top: 74,
      TN_pays_blank_position_16_Left: 26.6,
      TN_pays_blank_position_17_Left: 26.6,
    };
  }

  public static get nl(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get en(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get fi(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 78,
      TN_pays_blank_position_17_Top: 78,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get fr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get de(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get he(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 80,
      TN_pays_blank_position_17_Top: 80,
      TN_pays_blank_position_16_Left: 65,
      TN_pays_blank_position_17_Left: 65,
    };
  }

  public static get id(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get it(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75.5,
      TN_pays_blank_position_17_Top: 75.5,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get ja(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 77.5,
      TN_pays_blank_position_17_Top: 77.5,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get ko(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get nb(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get pl(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get 'pt-BR'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get ru(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get es(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 77.5,
      TN_pays_blank_position_17_Top: 77.5,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get sv(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get th(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get tr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get vi(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get ar(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 80,
      TN_pays_blank_position_17_Top: 80,
      TN_pays_blank_position_16_Left: 65,
      TN_pays_blank_position_17_Left: 65,
    };
  }

  public static get bg(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get ee(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 80.5,
      TN_pays_blank_position_17_Top: 80.5,
      TN_pays_blank_position_16_Left: 25.5,
      TN_pays_blank_position_17_Left: 25.5,
    };
  }

  public static get ge(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get gr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get 'hi-IN'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 74,
      TN_pays_blank_position_17_Top: 74,
      TN_pays_blank_position_16_Left: 25.5,
      TN_pays_blank_position_17_Left: 25.5,
    };
  }

  public static get hu(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get lt(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 25,
      TN_pays_blank_position_17_Left: 25,
    };
  }

  public static get kh(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 73,
      TN_pays_blank_position_17_Top: 73,
      TN_pays_blank_position_16_Left: 27,
      TN_pays_blank_position_17_Left: 27,
    };
  }

  public static get lv(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 77,
      TN_pays_blank_position_17_Top: 77,
      TN_pays_blank_position_16_Left: 25,
      TN_pays_blank_position_17_Left: 25,
    };
  }

  public static get mt(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get my(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get ph(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 74,
      TN_pays_blank_position_17_Top: 74,
      TN_pays_blank_position_16_Left: 26.5,
      TN_pays_blank_position_17_Left: 26.5,
    };
  }

  public static get ro(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 75,
      TN_pays_blank_position_17_Top: 75,
      TN_pays_blank_position_16_Left: 26.5,
      TN_pays_blank_position_17_Left: 26.5,
    };
  }

  public static get si(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 77,
      TN_pays_blank_position_17_Top: 77,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }

  public static get sk(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 78,
      TN_pays_blank_position_17_Top: 78,
      TN_pays_blank_position_16_Left: 26.5,
      TN_pays_blank_position_17_Left: 26.5,
    };
  }

  public static get 'sr-RS'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 77,
      TN_pays_blank_position_17_Top: 77,
      TN_pays_blank_position_16_Left: 25.5,
      TN_pays_blank_position_17_Left: 25.5,
    };
  }

  public static get 'ta-IN'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 25.8,
      TN_pays_blank_position_17_Left: 25.8,
    };
  }

  public static get ua(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top: 76,
      TN_pays_blank_position_17_Top: 76,
      TN_pays_blank_position_16_Left: 26,
      TN_pays_blank_position_17_Left: 26,
    };
  }
}

interface translateFontProp {
  TN_pays_blank_position_16_Top: number;
  TN_pays_blank_position_17_Top: number;
  TN_pays_blank_position_16_Left: number;
  TN_pays_blank_position_17_Left: number;
}
